import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl, getDateWithDay } from "../../comman/config.js";
import { VegRequirementFilter } from "../../components/Filter/VegRequirementFilter.js";
import toast, { Toaster } from "react-hot-toast";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import IssueModal from "../../components/IssueModal.js";
import Select from 'react-select';
import Loader from "../../components/Loader.js";
import NoRecordsFound from "../../components/NoRecordsFound.js";
import { saveAs } from 'file-saver';
import { menuAboveTable } from "../../comman/selectMenu";

// import Pagination from "react-js-pagination";

function IssueList() {
  const today = new Date().toISOString().split("T")[0];
  const [requirementList, setRequirementList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [session, setSession] = useState([]);
  const [issueStatus, setIssueStatus] = useState([]);
  const [item, setItem] = useState([]);
  const [kit,setKit] = useState({})
  const [kitList,setKitList] = useState([])
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemIngredientList, setItemIngredientList] = useState([]);
  const [methodList, setMethodList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [noRecordsFound, setNoRecordsFound] = useState(false);

  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    getMethodList()
  }, []);

  useEffect(()=>{
    getIngredientList()
  },[itemIngredientList])

  useEffect(() => {
   
    if(fromDate && toDate){
      getKitList();
    }
  }, [fromDate, toDate, session, item, issueStatus])

  useEffect(()=>{
    if(activeIndex !== null){
      getKitItemsList()
    }
  },[kit,item,activeIndex])

  const handelFilterChange = async (from_date, to_date, session, item,requirementStatus, orderStatus, orderId, purchaseStatus, receiptStatus,issueStatus, ingredient) => {
        console.log(issueStatus)
        setActiveIndex(null)
        setFromDate(from_date);
        setToDate(to_date);
        // setSession(session);
        // setItem(item);
        // setIssueStatus(issueStatus)
        setItem(Array.isArray(item) ? item : item ? [item] : []);
        setIssueStatus(Array.isArray(issueStatus) ? issueStatus : issueStatus ? [issueStatus] : []);
        setSession(Array.isArray(session) ? session : session ? [session] : []);
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = itemIngredientList?.map(item => item.ingredient_id) || [];
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 3 && !existingIngredientIds.includes(item.id));
    // console.log(list)
    setIngredientList(list);
  };

  const getMethodList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=method_master&condition=status=1`
    );
    setMethodList(response.data.data);
  };

  const getKitItemsList = async ()=>{
    setLoading(true)
    const kit = kitList.find((item, index) => index == activeIndex);
    // console.log(kit)
    const condition = `ird.menu_item_id='${kit.menu_item_id}' AND ird.date = '${kit.date}' AND ird.session='${kit.session}' AND ird.batch = '${kit.batch}' AND im.store = 3`;
    const RecipeDbData = await axios.get(`${baseUrl}/issue/ingredient_list?condition=${condition}`);
    const ingredientsList = RecipeDbData.data.data;
   
    if(ingredientsList.length > 0){
      const queries = ingredientsList.flatMap(i => [
        {
          key: `ird_${i.ingredient_id}`,
          table: 'item_requirement_detail',
          condition: `date = '${kit.date}' AND session = '${kit.session}' AND menu_item_id = '${kit.menu_item_id}' AND batch = '${kit.batch}' AND ingredient_id = '${i.ingredient_id}'`
        },
        {
          key: `ing_${i.ingredient_id}`,
          table: 'ingredients_master',
          condition: `id = '${i.ingredient_id}'`
        }
      ]);
      const batchResponse = await axios.post(`${baseUrl}/comman/batch-list`, { queries });
      const bd = batchResponse.data.data;

      const updatedIngredientsList = ingredientsList.map(i => {
          const irdRows = bd[`ird_${i.ingredient_id}`] ?? [];
          const ingRows = bd[`ing_${i.ingredient_id}`] ?? [];

          let wastage;
          let gross_qty;
          let gross_issued_qty;
          let issue_status;
          let available_qty;
          if(irdRows.length > 0){
            wastage = irdRows[0].wastage ?? 0;
            gross_qty = irdRows[0].gross_required_qty ?? 0;
            gross_issued_qty = irdRows[0].gross_issued_qty ?? 0;
            issue_status = irdRows[0].issue_status;
          }else{
            wastage = parseFloat(i.wastage ?? 0);
            gross_qty = (parseFloat(i.required_qty) + (parseFloat(i.required_qty) * (wastage / 100))).toFixed(2);
          }

          if(ingRows.length > 0){
            available_qty = ingRows[0].available_qty ?? 0;
          }

          const method = methodList.find((idx) => idx.id === i?.unit);
          const unitname = method?.name ?? "-";
          return {
            ...i,
            wastage: wastage,
            unitname: unitname,
            available_qty: available_qty,
            gross_required_qty: gross_qty,
            gross_issued_qty: gross_issued_qty,
            issue_status: issue_status
          };
        });
      setItemIngredientList(updatedIngredientsList);
    }
    setLoading(false)
  }

  const getKitList = async () => {
    setLoading(true)
    setNoRecordsFound(false)
    const itemArr = Array.isArray(item) ? item : item ? [item] : [];
    const issueStatusArr = Array.isArray(issueStatus) ? issueStatus : issueStatus ? [issueStatus] : [];
    const sessionArr = Array.isArray(session) ? session : session ? [session] : [];
    const itemIds = itemArr.map(i => i.value).join(',');
    const issueStatusValues = issueStatusArr.map(s => s.value).join(',');
    const sessionValues = sessionArr.map(s => s.value).join(',');
    let condition = `requirement_status = 2 AND ingredient_added = 2`;
    if(fromDate == toDate){
        condition += ` AND date = '${fromDate}' `;
    }else if(fromDate && toDate){
        
      condition += ` AND (date >= '${fromDate}' AND date  <= '${toDate}') `;
    }
    // if(session?.value && session?.value != "undefined"){
    //   condition += ` AND session = '${session?.value}'`;
    // }
    if (sessionValues && sessionValues !== "undefined" && sessionValues.value !== "") {
      const sessionArr = sessionValues.split(',').map(id => `'${id}'`).join(',');
      condition += ` AND session IN (${sessionArr})`;
    }
    // if(item?.value && item?.value != "undefined"){
    //   condition += ` AND menu_item_id = '${item?.value}'`;
    // }
    if (itemIds && itemIds !== "undefined" && itemIds.value !== "") {
      const itemArr = itemIds.split(',').map(id => `'${id}'`).join(',');
      condition += ` AND menu_item_id IN (${itemArr})`;
    }
    // if(issueStatus?.value && issueStatus != 'undefined'){
    //   condition += ` AND issue_status = '${issueStatus?.value}'`
    // }
    // Handle multiple receipt_status (comma-separated string)
    if (issueStatusValues && issueStatusValues !== "undefined" && issueStatusValues !== "" && issueStatusValues !== "0") {
      const statusArr = issueStatusValues.split(',').map(s => `'${s}'`).join(',');
      condition += ` AND issue_status IN (${statusArr}) `;
    }
    
        const response = await axios.get(`${baseUrl}/comman/list?table=item_requirement_master&condition=${condition}`)
        const kitList = response.data.data;
        const updatedKitList = await Promise.all(
          kitList.map(async (kit) => {
            const ingCondition = `ird.menu_item_id='${kit.menu_item_id}' AND ird.date = '${kit.date}' AND ird.session='${kit.session}' AND ird.batch = '${kit.batch}' AND im.store = 3`;
            const RecipeDbData = await axios.get(`${baseUrl}/issue/ingredient_list?condition=${ingCondition}`);
            const ingredientsList = RecipeDbData.data.data;
      
            // Return item only if ingredientsList is not empty
            if (ingredientsList && ingredientsList.length > 0) {
              return kit;
            }
      
            // Return null or undefined if the ingredientsList is empty
            return null;
          })
        );
    
        const filteredKitList = updatedKitList.filter((item) => item !== null);
        setKitList(filteredKitList)
        setNoRecordsFound(filteredKitList.length === 0);
        setLoading(false)
}
  const getRequirementList = async() => {
    // console.log(issueStatus);
    const response = await axios.post(`${baseUrl}/issue/list`,
      { from_date : fromDate,
        to_date :toDate,
        session :session?.value,
        item : item?.value,
        issue_status: issueStatus?.value
       
    });
    setRequirementList(response.data.data);
  }

  
  const handleSubmit = async() => {
   
    const response = await axios.post(`${baseUrl}/requirement/status_update`,
      { selectedRows : selectedRows,
        status: 2});

      toast.success("Data successfully saved!");
      getRequirementList();
  };

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(requirementList[index])
        ? selectedRows.filter(item => item !== requirementList[index]) // Deselect
        : [...selectedRows, requirementList[index]]; // Select

   setSelectedRows(updatedSelectedRows);
    

};
const handleSwitchSelectAll = () => {
  if (selectAll) {
      setSelectedRows([]);
  } else {
      setSelectedRows(requirementList.filter((item) => item.issue_status == 1)); // Select all rows
  }
  setSelectAll(!selectAll);
};

  const clearItem = () => {
    setActiveIndex(null)
    setSelectedItem(null);
    setItemIngredientList(null);
    getKitList()
  };

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
    setKit(kitList.find((item, i) => i == index))
  };
  

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    
    setItemIngredientList((prevFormData) => {
      const updatedFormData = [...prevFormData];
      // if(name === "net_issued_qty"){
      //   const required_qty = updatedFormData[index].required_qty;
      //   const diff_qty = (value - required_qty).toFixed(3);
      //   updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_qty : diff_qty };
      // }else{
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
      // }
      return updatedFormData;
    });
  };

  const handleSave = async() => {
    if(itemIngredientList.some(item => item.ingredient_id === null)){
      alert("One or more items have an empty ingredient value.");
      return
    }
    const issueCondition = itemIngredientList.some(item => 
      item.issue_status !== 3 && item.gross_issued_qty > item.available_qty
    );

    if(issueCondition){
      const commonline = `હાજર સ્ટોક કરતા વધારે ઇસ્યૂ થયેલ છે.`
      let confirmMessage = ``

      itemIngredientList.forEach(item => {
        if(item.issue_status !== 3 && item.gross_issued_qty > item.available_qty){
          confirmMessage += `${item.ingredient} ${commonline}\n`
        }
      })

      confirmMessage += `શું તમે આગળ વધવા માંગો છો?`
      const confirmed = window.confirm(confirmMessage)
      if(!confirmed) return
    }

    try{
        
        // console.log(itemIngredientList,kit)
      const response = await axios.post(`${baseUrl}/issue/ingredient_update`,
        { ingredientsList : itemIngredientList,
          item: kit});
          toast.success("Item added successfully!");
          clearItem()
    }catch (error) {
      toast.error("Failed to add item. Please try again.");
    }
    
  }

  const handleExport = async(e) => {
    e.preventDefault();
    try{
      const headerRow = ["Ingredient","Gross Issue Qty", "Gross Required Qty", "Net Required Qty", "Available Qty", "Issue Status"];
      
      const csv = [headerRow].concat(
        itemIngredientList.map(item => {
             // Replace status values with "active" or "inactive"
            const status = item.issue_status == 3 ? "Issued" : (item.issue_status == 2 ? "Partly Issue" : "Pending");
             // Create an array of values, including the modified status
             return [item.ingredient,item.gross_issued_qty,item.gross_required_qty, item.required_qty,item.available_qty, status].join(',');
           })).join('\n');
     
           // Create a Blob containing the CSV data
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  
        const kitName = kitList[activeIndex].kit_no.replace(/\//g, "_")
        // Trigger the file download using file-saver
        saveAs(blob, `veg_store_gross_${kitName}.csv`);
    }catch (error) {
      toast.error("Failed to export item. Please try again.");
    }
  }


  const handleAddNewIngredientRow = ()=> {
    setItemIngredientList([...itemIngredientList,{
      ingredient:'', 
      ingredient_obj:{},
      ingredient_id:null, 
      unit:null, 
      unitname:'', 
      wastage:0,
      gross_issued_qty:0, 
      // net_issued_qty:0, 
      gross_required_qty:0, 
      required_qty:0, 
      issue_status:1,
      isNew: true 
    }])
  }

  const handleNewIngredientChange = (selectedOptions,index) => {
    // setNewIngredient((prev)=>({...prev,ingredient:ingredient}))
    // console.log(selectedOptions)
    const updatedList =   [...itemIngredientList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    updatedList[index].unit = selectedOptions.unit
    updatedList[index].unitname = selectedOptions.unitname
    // console.log(updatedList[index])
    setItemIngredientList(updatedList)
  }

  return (
    <div className="p-2 sm:p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-2 sm:py-4 px-2 sm:px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Issue (Gross)
        </h1>

        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <VegRequirementFilter handleFilterChange={handelFilterChange} page="issue" />
      </div>
      {noRecordsFound && <NoRecordsFound />}
      <div>
        {kitList.map((item, index) => (
          <div key={index} className="border-b mt-4">
            <div
              className={`flex justify-between items-center p-4 cursor-pointer accordion-title border rounded
            ${item.issue_status == 1 ? 'bg-orange-400' :
                  (item.issue_status == 2 ? 'bg-yellow-400' : 'bg-green-400')}`}
              onClick={() => handleClick(index)}>
              <span className="text-sm sm:text-base">{`${item.kit_no} (${item.issue_status === 1 ? 'Pending issue' : (item.issue_status == 2 ? "Partly Issue" : "Issued")})`}</span>
              {index === activeIndex ? (
                <ChevronUpIcon className="w-6 h-6" />
              ) : (
                <ChevronDownIcon className="w-6 h-6" />
              )}
            </div>
            {index === activeIndex && (
              <div className="space-y-2 p-2 sm:p-4">

                {/* Desktop Table View */}
                <div className="hidden lg:block">
                  <table className="w-full mt-4 sm:mt-10 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                        <th scope="col" className="px-2 py-1 border border-black text-center w-60 ">Ingredient</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">Gross Issue Qty</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">Gross Required Qty</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">Net Required Qty</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center w-60 ">Available Qty</th>
                        <th scope="col" className="px-2 py-1 border border-black text-center ">Issue Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemIngredientList?.map((item, index) => (
                        <tr key={index} className="border border-black-b">
                          {item.isNew ? (<td className="px-2 py-1 border border-black text-center"><Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            className='basic-multi-select'
                            value={item.ingredient_obj}
                            name="ingredient"
                            onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                            options={ingredientList.map((item) => ({
                              value: item.id,
                              label: `${item.ingredient} (${item.eng_name})`,
                              unit: item.unit?.id,
                              unitname: item.unit?.name,
                              ingredient: `${item.ingredient}`,
                              eng_name: item.eng_name,
                            }))}
                            placeholder="Ingredient List"
                            filterOption={(option, inputValue) => {
                              return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                          /></td>) : <td className="px-2 py-1 border border-black text-center">{item.ingredient}</td>}
                          <td className="px-2 py-1 border border-black text-center"><input type="number"
                            id="gross_issued_qty"
                            name="gross_issued_qty"
                            disabled={item.issue_status === 3}
                            value={item?.gross_issued_qty}
                            onChange={handleInputChange(index)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                          /></td>
                          <td className="px-2 py-1 border border-black text-center">{item?.gross_required_qty}</td>
                          <td className="px-2 py-1 border border-black text-center">{item?.required_qty}</td>
                          {<td className="px-2 py-1 border border-black text-center">{item.available_qty}</td>}
                          <td className="px-2 py-1 border border-black text-center">{item.issue_status == 3 ? "Issued" : (item.issue_status == 2 ? " Partly Issue" : "Pending")}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Mobile Card View */}
                <div className="lg:hidden mt-4">
                  {itemIngredientList?.map((item, index) => (
                    <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm mb-4 p-4">
                      <div className="flex justify-between items-center mb-3">
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${item.issue_status == 3 ? 'bg-green-100 text-green-800' :
                            item.issue_status == 2 ? 'bg-yellow-100 text-yellow-800' :
                              'bg-orange-100 text-orange-800'
                          }`}>
                          {item.issue_status == 3 ? "Issued" : (item.issue_status == 2 ? "Partly Issue" : "Pending")}
                        </span>
                      </div>

                      <div className="space-y-3">
                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Ingredient</label>
                          {item.isNew ? (
                            <Select
                              classNamePrefix="select"
                              className='basic-multi-select w-full'
                              value={item.ingredient_obj}
                              name="ingredient"
                              onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                              options={ingredientList.map((item) => ({
                                value: item.id,
                                label: `${item.ingredient} (${item.eng_name})`,
                                unit: item.unit?.id,
                                unitname: item.unit?.name,
                                ingredient: `${item.ingredient}`,
                                eng_name: item.eng_name,
                              }))}
                              placeholder="Ingredient List"
                              filterOption={(option, inputValue) => {
                                return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                              }}
                              menuPortalTarget={document.body}
                              menuPosition="fixed"
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 9999
                                })
                              }}
                            />
                          ) : (
                            <div className="p-2 bg-gray-50 rounded border text-sm">{item.ingredient}</div>
                          )}
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Gross Issue Qty</label>
                          <input
                            type="number"
                            id="gross_issued_qty"
                            name="gross_issued_qty"
                            disabled={item.issue_status === 3}
                            value={item?.gross_issued_qty}
                            onChange={handleInputChange(index)}
                            onWheel={(e) => e.target.blur()}
                            onKeyDown={(e) => {
                              if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                e.preventDefault();
                              }
                            }}
                            className="w-full px-3 py-2 border rounded-md bg-orange-50"
                          />
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">Gross Required Qty</label>
                            <div className="p-2 bg-gray-50 rounded border text-sm text-center">
                              {item?.gross_required_qty}
                            </div>
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">Net Required Qty</label>
                            <div className="p-2 bg-gray-50 rounded border text-sm text-center">
                              {item?.required_qty}
                            </div>
                          </div>
                        </div>

                        <div>
                          <label className="block text-xs font-medium text-gray-700 mb-1">Available Qty</label>
                          <div className="p-2 bg-gray-50 rounded border text-sm text-center">
                            {item.available_qty}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-end p-2 sm:p-6 border-t border-solid border-blueGray-200 rounded-b space-y-2 sm:space-y-0 sm:space-x-2">
                  {kit.issue_status !== 3 && (<>
                    <button
                      className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                      type="button"
                      disabled={kit.issue_status == 3}
                      onClick={() => handleSave()}
                    >
                      Submit for Issue
                    </button>
                    <button
                      className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                      type="button"
                      disabled={kit.issue_status === 3}
                      onClick={() => { handleAddNewIngredientRow() }}
                    >
                      Add Ingredient
                    </button></>)}
                  <button
                    onClick={handleExport}
                    className="w-full sm:w-auto px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200">
                    Export
                  </button>
                </div>
              </div>)}
          </div>
        ))}
      </div>
    </div>
  );
}

export default IssueList;
